<template>
    <div class="bg-white border border-gray-200 rounded">
        <slot />
    </div>
</template>

<script setup>

</script>